import { Component, input, model, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primeng/accordion'
import { TreeNode } from 'primeng/api'
import { Drawer } from 'primeng/drawer'
import { Select } from 'primeng/select'
import { SkeletonModule } from 'primeng/skeleton'
import { TreeModule } from 'primeng/tree'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { CategoryFilterComponent } from 'app/_shared/components/filter-tree/category-filter.component'
import { SortOption, SortDescriptor } from 'app/_shared/interfaces/Category'

@Component({
  selector: 'app-mobile-filters',
  standalone: true,
  imports: [
    Select,
    FormsModule,
    ButtonComponent,
    CategoryFilterComponent,
    TreeModule,
    SkeletonModule,
    Drawer,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent
  ],
  templateUrl: './mobile-filters.component.html',
  styleUrl: './mobile-filters.component.scss'
})
export class MobileFiltersComponent {
  sortingOptions = input.required<SortOption[]>()
  leadCategoryId = input<number>()
  brands = input<TreeNode[]>([])
  brandsLoading = input<boolean>(false)

  visible = model.required<boolean>()
  selectedCategoryIds = model.required<number[]>()
  selectedBrands = model<TreeNode[]>([])
  selectedSort = model<SortDescriptor | undefined>()
  search = model<string>('')

  applyFilters = output<void>()
  clearFilters = output<void>()

  onFiltersChanged() {
    // Track changes but don't apply until user clicks "See Results"
  }

  onApplyFilters() {
    this.visible.set(false)
    this.applyFilters.emit()
  }

  onClearFilters() {
    this.selectedCategoryIds.set([])
    this.selectedBrands.set([])
    this.selectedSort.set(undefined)
    this.search.set('')
    this.clearFilters.emit()
  }
}
